import config from "config/config";

export const airLuggagePolicy = (maxBags?: number) => {
  switch (maxBags) {
    case 1:
      return config.airLuggageIpidVersion + "010424.pdf";
    case 2:
      return config.airLuggageIpidVersion + "120324.pdf";
    case 4:
      return config.airLuggageIpidVersion + "050623.pdf";
    default:
      return config.airLuggageIpidVersion + "010424.pdf";
  }
};

export const airPayoutPolicy = (required24hDepartureTime?: boolean) => {
  if (required24hDepartureTime) {
    return config.airPayoutIpidVersion + "120324.pdf";
  }
  return config.airPayoutIpidVersion + "010424.pdf";
};

export const policyUrl = (isAirPayout: boolean, ipid_version?: string) => {
  if (isAirPayout) {
    return config.airPayoutIpidVersion + ipid_version + ".pdf";
  }
  return config.airLuggageIpidVersion + ipid_version + ".pdf";
};
